<template>
    <client-only>
        <portal
            to="limb"
            ref="portal"
        >
            <div
                class="cases-dropdown"
                :class="classList"
                :id="ddId"
                :ref="`dropdown-${modalName}`"
                v-on="listenMouseover ? {
                    mouseover: handlerover,
                    mouseleave: handlerleave
                } : {}
                "
            >
                <div
                    class="cases-dropdown-content"
                    :class="ddContentClasses"
                    :style="{width: width || bindedWidth}"
                    v-bsl="visible && $mq == 'xs'"
                    :id="layoutId"
                    :ref="`content-${modalName}`"
                >
                    <slot v-if="render" />
                </div>
            </div>
        </portal>
    </client-only>
</template>


<script>
import { createPopper } from '@popperjs/core';
import { findScrollableParent } from '~/utilities/scroll.js';
import modalNavigation from '~/mixins/modalNavigation.js';

export default {
    mixins: [modalNavigation],

    name: 'CasesDropdown',

    props: [
        'modalName', 'classes', 'anchorId', 'placement',
        'listenMouseover', 'fallbackPlacements', 'contentClasses',
        'width', 'bindWidthId'
    ],

    data () {
        return {
            // popperInstance: null,
            render: false,
            bindedWidth: null,
            visible: false,

            modalType: 'dropdown', // required for modalNavigation

            touchStartY: 0,
            touchDeltaY: 0,
            isDragging: false,
            dragStarted: false
        }
    },

    // Non-reactive popperInstance
    popperInstance: null,

    computed: {
        layoutId () {
            return `${this.ddId}-layout`;
        },

        dd () {
            return this.$modalityStore.dropdowns.find(o => o.name == this.modalName);
        },

        open () {
            return !!this.dd;
        },

        classList () {
            let classList = this.classes || [];
            classList = classList.slice(0) // clone array
            if (this.open) classList.push('active');
            return classList
        },

        ddId () {
            return `dropdown-${this.modalName}`;
        },

        closableId () {
            return `[data-closable="${this.modalName}-dd"]`
        },

        ddAnchorId () {
            return this.dd && this.dd.anchorId || this.anchorId;
        },

        ddPlacement () {
            return this.dd && this.dd.placement || this.placement || 'right-start';
        },

        ddContentClasses () {
            let classes = this.contentClasses ? [...this.contentClasses] : [];
            if (this.bindedWidth) classes.push('binded-width')
            return classes;
        }
    },

    watch: {
        open (newVal) {
            if (process.server) return;

            if (newVal) {
                this.render = true;
                this.visible = true;
                this.updateWidth();

                document.body.addEventListener('click', this.clickHandle);
                window.addEventListener('resize', this.updateWidth);
                this.$emit("show");

                this.$nextTick(() => {
                    this.initPopper();
                    if (this.$refs[`content-${this.modalName}`]) {
                        this.$refs[`content-${this.modalName}`].scrollTop = 0;
                    }
                });

                if (process.client) {
                    setTimeout(() => {
                        this.$cropContent();
                    }, 100);
                }
            } else {
                this.destroyPopper();
                this.$emit("hide");

                document.body.removeEventListener('click', this.clickHandle);
                window.removeEventListener('resize', this.updateWidth);

                if (process.client) {
                    setTimeout(() => {
                        if (!this.open) this.visible = false;

                    }, 350)

                    
                    setTimeout(() => {
                        if (!this.open) this.render = false;
                    }, 1000)
                }
            }
            
            if (newVal && window.innerWidth < 576) {
                this.addSwipeListeners();
            } else {
                this.removeSwipeListeners();
            }
        },
    },

    methods: {
        updateWidth () {
            if (!this.bindWidthId) return;

            let element = this.bindWidthId;

            if (typeof this.bindWidthId == 'string') {
                element = document.getElementById(this.bindWidthId)
            }
            
            if (!element) return;

            this.bindedWidth = element.offsetWidth + 'px';
        },

        clickHandle (e) {
            if (!this.open) return;

            let excludedElement = e.target.closest(this.closableId);
            let ddEl = document.getElementById(this.ddId);

            if (
                !ddEl ||
                (!excludedElement && !(ddEl == e.target || ddEl.contains(e.target)))
            ) this.close();
        },

        close (e) {
            if (!this.open) return true;
            this.$modalityStore.closeDropdown({name: this.modalName});
        },

        initPopper () {
            // if (this.$mq == 'xs') this.$cropContent();

            if (this.timeOut) clearTimeout(this.timeOut);

            let anchor   = document.getElementById(this.ddAnchorId);
            let dropdown = document.getElementById(this.ddId);
            if (!anchor || !dropdown) return;

            let modifiers = [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    }
                }
            ]

            if (this.fallbackPlacements) {
                modifiers.push({
                    name: 'flip',
                    options: {
                        fallbackPlacements: this.fallbackPlacements
                    }
                })
            }

            this.$options.popperInstance = createPopper(anchor, dropdown, {
                strategy: 'fixed',
                placement: this.ddPlacement,
                modifiers
            });

            this.$options.popperInstance.forceUpdate();
        },

        destroyPopper () {
            this.timeOut = setTimeout( () => {
                if (this.$options.popperInstance) {
                    this.$options.popperInstance.destroy();
                    this.$options.popperInstance = null;
                }
            }, 1000);
        },

        forceUpdate () {
            if (this.$options.popperInstance) this.$options.popperInstance.forceUpdate();
        },

        handlerover () { this.$emit('mouseover')},
        handlerleave () { this.$emit('mouseleave')},


        addSwipeListeners() {
            this.$nextTick(() => {
                const content = this.$refs[`content-${this.modalName}`];
                if (!content) return;

                content.addEventListener('touchstart', this.onTouchStart, { passive: true });
                content.addEventListener('touchmove', this.onTouchMove, { passive: false });
                content.addEventListener('touchend', this.onTouchEnd, { passive: true });
            });
        },

        removeSwipeListeners() {
            const content = this.$refs[`content-${this.modalName}`];
            if (!content) return;

            content.removeEventListener('touchstart', this.onTouchStart);
            content.removeEventListener('touchmove', this.onTouchMove);
            content.removeEventListener('touchend', this.onTouchEnd);
        },

        onTouchStart(e) {
            if (window.innerWidth >= 576 || e.touches.length !== 1) return;

            this.touchStartY = e.touches[0].clientY;
            this.touchDeltaY = 0;
            this.isDragging = false;
            this.dragStarted = false;

            const container = this.$refs[`content-${this.modalName}`];
            const touchedElement = e.target;

            this.scrollableTarget = findScrollableParent(touchedElement, container);
        },

        onTouchMove(e) {
            const content = this.$refs[`content-${this.modalName}`];
            const dropdown = this.$refs[`dropdown-${this.modalName}`];

            if (window.innerWidth >= 576 || !content || !dropdown) return;

            // 🧠 Get the scrollable target found during touchstart
            const scrollable = this.scrollableTarget;

            // Still allow scroll until we reach top
            if (scrollable && scrollable.scrollTop > 0) return;

            const currentY = e.touches[0].clientY;
            const deltaY = currentY - this.touchStartY;

            this.touchDeltaY = deltaY;
            this.isDragging = true;

            const translateY = Math.max(this.touchDeltaY, 0);
            dropdown.style.setProperty('transform', `translateY(${translateY}px)`, 'important');

            if (translateY > 0) {
                dropdown.classList.add('dragging');
                // try { e.preventDefault(); } catch (_) {}
            }
        },

        onTouchEnd() {
            const content = this.$refs[`content-${this.modalName}`];
            const dropdown = this.$refs[`dropdown-${this.modalName}`];
            if (!this.isDragging || !content || !dropdown) return;

            dropdown.classList.remove('dragging');

            if (this.touchDeltaY > 150) this.close();

            dropdown.style.transform = '';
            this.touchDeltaY = 0;
            this.isDragging = false;
            this.scrollableTarget = null;
        }
    }
}
</script>
